import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	.results-wrapper {
		padding: 2em 0;
		max-width: 1366px;
		margin: 0 auto;
		cursor: pointer;

		.results-header {
			display: flex;
			justify-content: center;
			padding: 0 2em 3em 2em;

			.results-title {
				font-size: 1.6em;
			}
		}

		.list {
			.results-list {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 1em;
				row-gap: 2em;

				.result-wrapper {

					width: 100%;
					overflow: hidden;
					border: 0.06em solid ${vars.colorBlack};
					color: inherit;
					text-decoration: inherit;

					.result-image-box {
						overflow: hidden;
						height: 10em;
						width: 100%;
						border-bottom: 0.06em solid ${vars.colorBorder};

						.result-image {
							height: auto;
							object-fit: contain;
							width: 100%;
							height: 100%;
						}
					}

					.result-details-cols {
						display: flex;
						justify-content: flex-start;
						height: 9em;
						background-color: ${vars.colorBackgroundContrast};

						.result-details-col {
							width: 65%;
							display: flex;
							flex-flow: column wrap;
							padding: 1em;

							.company-name {
								font-size: 1.1em;
								height: 2.4em;
								margin: 0 0 0.7em 0;
								overflow: hidden;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
								text-overflow: ellipsis;
							}

							.company-category {
								height: 1.4em;
								overflow: hidden;
								margin: 0 0 0.7em 0;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
								text-overflow: ellipsis;
							}

							.company-jobs {
								height: 1.4em;
								overflow: hidden;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
								text-overflow: ellipsis;
							}
						}
						.result-logo-col {
							width: 35%;
							overflow: hidden;
							border-left: 0.09em solid ${vars.colorBorder};
							padding: 1em;
							display: flex;

							.result-logo {
								max-width: 100%;
								max-height: 100%;
								object-fit: scale-down;
							}
						}
					}
				}
			}

			.layout-spinner {
				grid-area: 1 / 2 / 2 / 3;
				padding: 3em;
			}
		}

		.layout-pagination {
			ul {
				padding: 0;
			}
		}

		.empty {
			display: flex;
			flex-flow: column wrap;
			justify-content: center;
			align-items: center;
			padding: 0 0 6em 0;

			.empty-title {
				margin: 0 0 2em 0;
			}
			.empty-subtitle {
				text-align: center;
			}
		}
	}

	@media all and (max-width: ${vars.desktopS}) {
		.results-wrapper {
			.list {
				.results-list {
					padding: 0 2em;
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.results-wrapper {
			.list {
				.results-list {
					display: flex;
					flex-flow: column wrap;
					padding: 0 2em;
				}
			}
		}

	}
`;
